<script setup lang="ts">
const appStateStore = useAppStateStore();
const merchant = computed(() => appStateStore.currentMerchant);
</script>
<template>
  <HeadlessPopover
    v-slot="{ open, close }"
    class="relative text-neutral-200 hover:hover:bg-[#141414] rounded-lg">
    <HeadlessPopoverButton
      class="focus:outline-hidden flex items-center gap-2 cursor-pointer"
      data-test="button-header-nav">
      <img
        :src="getGameIcon(merchant)"
        :alt="$t(`main.merchant.${merchant}`)"
        class="w-16 h-16 rounded-lg" />
      <NuxtIcon
        name="mdi:chevron-down"
        alt="icon of arrow pointing down"
        class="w-6 h-6 text-neutral-200 font-bold" />
      <!--<NuxtIcon
    :name="open ? 'mdi:close' : 'mdi:hamburger-menu'"
    aria-label="Open games menu"
    class="text-4xl text-neutral-300 cursor-pointer" />-->
    </HeadlessPopoverButton>
    <transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="transform opacity-0 -translate-x-full"
      enter-to-class="transform opacity-100"
      leave-active-class="transition ease-in duration-200"
      leave-from-class="transform opacity-100"
      leave-to-class="transform opacity-0 -translate-x-full">
      <HeadlessPopoverPanel
        class="fixed top-[0px] md:top-0 bottom-0 left-0 right-0 w-full md:w-fit bg-neutral-800 z-30 shadow-sm shadow-black overflow-y-scroll border-t md:border-0 border-secondary-400">
        <HeaderNavGamesItems :close="close" />
      </HeadlessPopoverPanel>
    </transition>
  </HeadlessPopover>
</template>
